import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function HeroSlide() {
  return <div className="h-full w-full flex flex-col items-center justify-center text-center px-8 relative overflow-hidden bg-slate-950" data-id="element-51">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-52">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl" data-id="element-53" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" data-id="element-54" />
      </div>

      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="mb-12 relative" data-id="element-55">
        <div className="absolute inset-0 bg-blue-500 blur-2xl opacity-20 rounded-full" data-id="element-56" />
        <Zap className="w-32 h-32 text-blue-500 relative z-10" strokeWidth={1.5} data-id="element-57" />
      </motion.div>

      <motion.h1 initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.3,
      duration: 0.8
    }} className="text-6xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-58">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-green-400" data-id="element-59">
          Your Charging, Your Way
        </span>
      </motion.h1>

      <motion.p initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.5,
      duration: 0.8
    }} className="text-xl md:text-2xl text-slate-400 max-w-3xl leading-relaxed" data-id="element-60">
        Smart charging made simple for CPOs to scale
      </motion.p>
    </div>;
}